import { inject } from "@angular/core";
import { CanActivateFn } from "@angular/router";
import { UserProfileService } from "app/shared/user-profile/user-profile.service";
import { filter, map } from "rxjs";



export const RevenuesV1Guard: CanActivateFn = () => {
  const userProfileService = inject(UserProfileService);
  return userProfileService.userProfileLoaded().pipe(filter(loaded => loaded),map( _ => {
    return userProfileService.hasAccessToRevenuesV1();
  }));
  
}